import { PayloadAction } from '@reduxjs/toolkit';
import { IState } from '../types';

const updateRoadsideServices = (
  state: IState,
  action: PayloadAction<{ roadsideServiceKeys: number[] }>,
) => {
  const { roadsideServiceKeys } = action.payload;
  const keysSet = new Set(roadsideServiceKeys);

  state.roadsideService = state.initRoadsideService.filter((service) =>
    keysSet.has(Number(service.code)),
  );
};

export default updateRoadsideServices;
